export default "__VITE_ASSET__CUjHq89w__"